

import React, { createContext, useContext, useState, useEffect } from "react";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  // const [cart, setCart] = useState(() => {
  //   // Load initial cart from localStorage
  //   const savedCart = localStorage.getItem("cart");
  //   return savedCart ? JSON.parse(savedCart) : [];
  // });

  // // Save cart to localStorage whenever it changes
  // useEffect(() => {
  //   localStorage.setItem("cart", JSON.stringify(cart));
  // }, [cart]);
    const [cart, setCart] = useState([]); 

  const addToCart = (item) => {
    setCart((prev) => [...prev, item]);
  };

  const removeFromCart = (index) => {
    setCart((prev) => prev.filter((_, i) => i !== index));
  };

  // const clearCart = () => {
  //   setCart([]);
  // };

   const setCartCount = (items) => setCart(items);
  return (
    <CartContext.Provider value={{ cart, addToCart, removeFromCart, setCartCount }}>
      {children}
    </CartContext.Provider>
  );
};

// ✅ For functional components
export const useCart = () => useContext(CartContext);
